import { GetBookingsRequest } from '../types'
import { GetBookingsRequestDTO } from '../dtoTypes'

export const adaptBookingsRequestToDTO = (
    request?: GetBookingsRequest,
    pagination?: { size: number, page: number}
): GetBookingsRequestDTO => {
    return {
        start_time: request?.startTime
            ? request.startTime.toISOString()
            : undefined,
        end_time: request?.endTime ? request.endTime.toISOString() : undefined,
        order_by: request?.orderBy ?? 'start_time',
        counterparty_type: request?.counterpartyType ?? -1,
        page: pagination?.page ?? 1,
        size: pagination?.size ?? 50,
        order_asc: request?.orderAsc?.toString() ?? 'false',
        search_param: request?.searchParam,
    }
}
